<template>
  <div class="view">
    <div class="content">
      <div class="notice">
        <p>
          <i class="el-alert__icon el-icon-warning"></i>此处只统计所选月份已付款订单。
        </p>
      </div>
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <span class="choosedep"></span>
              <el-button @click="choosedep" size="small">选择部门</el-button>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formdata.user" placeholder="输入姓名查询" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="formdata.user" type="date" placeholder="选择日期" size="small"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="other_wrap">
          <el-button type="primary" @click="exportfile" size="small">导出</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="头像"></el-table-column>
          <el-table-column prop="name" label="业务员"></el-table-column>
          <el-table-column prop="address" label="手机"></el-table-column>
          <el-table-column prop="address" label="部门"></el-table-column>
          <el-table-column prop="address" label="成交订单数"></el-table-column>
          <el-table-column prop="address" label="成交金额"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- @click="handleClick(scope.row)" -->
              <el-button type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <chooseDepDialog
      :visible.sync="choosedepdialog"
      v-if="choosedepdialog"
      @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
  </div>
</template>
<script>
import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "employeeOrderList",
  components: {
    chooseDepDialog
  },
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      choosedepdialog: false
    };
  },
  methods: {
    // 选择部门
    choosedep() {
      this.choosedepdialog = true;
    },
    choosedepsucess(val) {
      // this.formdata.depart_name = val.name;
      // this.formdata.depart_id = val.id;
    },
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 导出
    exportfile() {}
  }
};
</script>
